import * as React from "react";
import styled from "styled-components";
import { defaultFontStack } from "../../styles/typography/v2/font-stack";
import EmailForm from "../form/email/email-form";
import Icon from "./icon";
import { Script } from "gatsby";

const Root = styled.div(({ theme }) => ({
  display: "flex",
  minHeight: 45,
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: theme.colors.deep,
  color: theme.colors.day,
  padding: "2px 16px",
  gap: 10,
  "@media(min-width: 800px)": {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 16px",
  },
}));

const Left = styled.div({
  display: "flex",
  alignItems: "center",
  gap: 10,
  "@media(min-width: 800px)": {
    flexGrow: 1,
  },
});

const Text = styled.span(defaultFontStack, {
  fontSize: 19,
  fontWeight: 300,
});

const WatchButton = styled.button(defaultFontStack, ({ theme }) => ({
  background: theme.colors.day,
  fontWeight: 600,
  color: "#000000",
  fontSize: 18,
  borderRadius: 25,
  padding: "5px 14px",
  border: 0,
  minWidth: "fit-content",
  whiteSpace: "nowrap",
}));

export function LeanProductionBanner() {
  const [submitted, setSubmitted] = React.useState(false);

  const onSubmit = () => {
    setSubmitted(true);
    window.Wistia.api("fi471vh0c7").play();
  };

  const onWatch = () => {
    window.Wistia.api("fi471vh0c7").play();
  };

  return (
    <Root>
      <Left>
        <Icon />
        <Text>
          Discover the <span style={{ fontWeight: 500 }}>5 Deadly Sins</span>{" "}
          and <span style={{ fontWeight: 500 }}>5 Quick Wins</span> of OEE in a
          30-minute video presentation.
        </Text>
      </Left>
      <div>
        {submitted ? (
          <WatchButton onClick={onWatch}>Watch Now</WatchButton>
        ) : (
          <EmailForm
            formId="6a3cbf30-fa85-ef11-ac21-6045bdd6ed67"
            onSubmit={onSubmit}
          />
        )}
      </div>
      <div class="wistia_embed wistia_async_fi471vh0c7 popover=true popoverAnimateThumbnail=true"></div>
      <Script src="https://fast.wistia.com/embed/medias/fi471vh0c7.jsonp" />
      <Script src="https://fast.wistia.com/assets/external/E-v1.js" />
    </Root>
  );
}
